/** @format */

import React, { ChangeEvent, useCallback, useEffect, useState } from 'react';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import { SimpleSelect, SimpleSelectElements } from '../../../components/Adescom/SimpleSelect';
import PlatformResellerInterface from '../../../interfaces/platform/PlatformResellerInterface';
import { REQUEST_STATE } from '../../../helpers/RequestHelper';
import { PlatformResellerSendType } from '../PlatformResellerModify';
import CustomMultiSelect from '../../../components/Form/CustomMultiSelect';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import { configDefault } from '../../../core/config';
import { SYSTEM_LANGUAGE_ACTIONS } from '../../../modules/language/actions';
import { SystemLanguageCollectionInterface } from '../../../modules/language/interfaces/SystemLanguageInterface';
import { useDispatch } from 'react-redux';
import { SystemCurrencyCollectionInterface, SystemCurrencyInterface } from '../../../modules/currency/interfaces/SystemCurrencyInterface';
import Loader from '../../../components/Loaders/Loader';
import { CountryCodeCollectionInterface } from '../../../interfaces/collections/CountryCodeCollectionInterface';
import CircularProgress from '@material-ui/core/CircularProgress';
import CountryCodeInterface from '../../../interfaces/platform/CountryCodeInterface';

interface PlatformResellerCountryCodePropsInterface {
    platformResellerId: string | null | undefined;
    platformReseller: PlatformResellerInterface | PlatformResellerSendType;
    changeCountryCodeCallback: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

const PlatformResellerCountryCode: React.FC<PlatformResellerCountryCodePropsInterface> = (props) => {
    const { platformReseller, platformResellerId } = props;
    const dispatch = useDispatch();
    const [countryCode, setCountryCode] = useState<Array<CountryCodeInterface>>([]);
    const [loadingFinished, setLoadingFinished] = useState<boolean>(false);

    const loadItemsPage = useCallback((specificPage: string | null) => {
        const itemLoader = new ItemLoaders(dispatch);
        const defaultUri = FormGeneralHelper.getPath('/country_codes', configDefault.PLATFORM_API_PREFIX);
        itemLoader.getListWithCallback(
            FormGeneralHelper.getByUri(specificPage ? specificPage : defaultUri),
            SYSTEM_LANGUAGE_ACTIONS.LIST,
            [
                {
                    name: 'itemsPerPage',
                    value: 100,
                }
            ],
            [
                {
                    name: 'renderOrder',
                    value: 'ASC',
                },
            ],
            {
                onSuccess: (data: CountryCodeCollectionInterface) => {
                    setCountryCode(countryCode => countryCode ? [...countryCode, ...data['hydra:member']] : data['hydra:member']);

                    if('hydra:next' in data['hydra:view']) {
                        loadItemsPage(data['hydra:view']['hydra:next']);
                    } else {
                        setLoadingFinished(true);
                    }
                },
                onError: (error: any) => {
                    console.log(error);
                    setLoadingFinished(true);
                    // setCountryCode([]);
                },
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    }, [dispatch]);

    useEffect(() => {
        loadItemsPage(null);
    }, [loadItemsPage]);

    const saveCallback = (event: React.ChangeEvent<HTMLSelectElement>): void => {
        props.changeCountryCodeCallback(event);
    };

    const preprocessUri = (uri: string): string => {
        return '/api/' + uri.split('/api/')[1];
    };

    return (
        <>
            {loadingFinished && countryCode && (
                <SimpleSelect
                    key={'countryCode'}
                    label={'platform_reseller:pr.reseller_country_code'}
                    required={true}
                    elements={countryCode.map((el: CountryCodeInterface) => {
                        return {
                            name: `[${el.shortCode}] ${el.description}`,
                            value: '/api/' + el['@id'].split('/api/')[1],
                        } as SimpleSelectElements;
                    })}
                    dispatchName={'countryCode'}
                    fieldName={'countryCode'}
                    selectedValue={preprocessUri(platformReseller.countryCode)}
                    callback={saveCallback}
                />
            )}
            {!loadingFinished && <CircularProgress />}
        </>
    );
};

export default PlatformResellerCountryCode;
